export const auth0Config = {
  client_id: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  redirect_uri: process.env.REACT_APP_AUTH0_REDIRECT_URI,
  audience: process.env.REACT_APP_AUTH0_AUDIENCE
};

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET
};

// Inactivity session-timeout policy. The dashboard signs a user out after a
// period of no interaction, showing a countdown warning first. Defaults match
// the "must not exceed 30 minutes of inactivity" requirement; both values are
// overridable via env for staging/testing without a code change.
export const sessionConfig = {
  // Hard logout after this much inactivity (milliseconds).
  idleMs: Number(process.env.REACT_APP_IDLE_TIMEOUT_MS) || 30 * 60 * 1000,
  // How long before the hard logout the warning dialog is shown (milliseconds).
  warningMs: Number(process.env.REACT_APP_IDLE_WARNING_MS) || 60 * 1000
};

// sessionStorage key set when a user is signed out for inactivity, so the login
// screen can explain why they landed back there.
export const SESSION_LOGOUT_REASON_KEY = 'sessionLogoutReason';
export const SESSION_LOGOUT_REASON_INACTIVITY = 'inactivity';
// The access token could not be renewed (refresh token expired or revoked).
export const SESSION_LOGOUT_REASON_EXPIRED = 'expired';
// Auth0 reports a failed sign-in on the return URL; the app's redirects drop
// the query string, so it is parked here for the Login page to show.
export const SESSION_AUTH_ERROR_KEY = 'authError';
